
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Info = props => {
  const modClassName = props.className ? props.className + ' fe_c_icon--info-solid' : ' fe_c_icon--info-solid';

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g>
          <circle cx="12.5" cy="12.5" r="10.6" className="fe_c_icon__icon fe_c_icon__icon--secondary"></circle>
          <g className="fe_c_icon__icon fe_c_icon__icon--invert">
            <circle cx="12.375" cy="7.375" r="1.35"></circle>
            <polygon points="14.49 17.28 10.51 17.28 10.51 16.31 11.67 16.31 11.67 11.63 10.51 11.63 10.51 10.6 13.33 10.6 13.33 16.31 14.49 16.31 14.49 17.28"></polygon>
          </g>
        </g>
      </g>
    </IconBase>);
};

Info.defaultProps = {
  title: 'Info',
};

export default Info;
